module.exports = __webpack_public_path__ + "static/img/x4.9c523959.png";